
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Swiper, { A11y, Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';
import { IItemGroup } from './FilmInfoTab.vue';
import { SanityDocumentSchema } from '~/types/sanity-documents';

@Component
export default class FilmMediaTab extends Vue {
  @Prop({ type: Array, default: [] })
  readonly items!: IItemGroup[];

  schemas = SanityDocumentSchema;

  mounted() {
    const el = this.$refs?.swiperContainer as HTMLElement;
    if (!el) {
      return;
    }

    new Swiper(el, {
      slidesPerView: 'auto',
      modules: [A11y, Navigation, Pagination],
      navigation: {
        nextEl: '.film-extra-media-swiper-button-next',
        prevEl: '.film-extra-media-swiper-button-prev',
      },
      pagination: {
        clickable: true,
        el: '.film-extra-media-swiper-pagination',
        type: 'bullets',
      },
      a11y: {
        nextSlideMessage: this.$t(
          'components.films.filmMediaTab.nextSlide',
        ) as string,
        prevSlideMessage: this.$t(
          'components.films.filmMediaTab.prevSlide',
        ) as string,
        paginationBulletMessage: this.$t(
          'components.films.filmMediaTab.goToSlide',
          { i: '{{index}}' },
        ) as string,
        slideLabelMessage: this.$t('components.films.filmMediaTab.slideLabel', {
          current: '{{index}}',
          total: '{{slidesLength}}',
        }) as string,
      },
    });
  }

  get refIds() {
    const allRefs: { refs?: Record<string, boolean> } = {};
    this.items.forEach((item) => {
      if (item.titleRefId && !allRefs?.refs?.[item.titleRefId]) {
        if (!allRefs?.refs) {
          allRefs.refs = {};
        }
        allRefs.refs[item.titleRefId] = true;
      }
    });
    return allRefs.refs ? Object.keys(allRefs.refs) : [];
  }

  @Watch('refIds')
  handleRefsChange(
    current: string[] | undefined,
    previous: string[] | undefined,
  ) {
    if (current?.length) {
      this.$sanityLookup.fetchReference({
        _id: current,
        _type: this.schemas.MEDIA_TYPE,
      });
    }
  }
}
